import { httpCadastro } from '../plugins/http'

const endpoint = '/v1/cadastro/mdfe-distribuicao'

//
// MDF-e de distribuicao: a carga chega ao CD dentro de MDF-e encerrados e
// e remontada em MDF-e por regiao para a perna final.
//
// Dois grupos de chamada aqui. As de consulta (listarMdfeEncerrados,
// listar) leem e nao gravam - servem para conferir o que chegou. As de
// rodada (abrir, aberta, buscar, finalizar) gravam: congelam os CT-e que
// a consulta mostrou para a rodada sobreviver ao fechamento da tela.
// Nenhuma emite documento nem consome numeracao.
//
// A API e restrita a MODERADOR e ADMIN (SecurityConfiguration da
// wi-cadastro-api), e o menu do portal segue a mesma regra.
//
export default {

  listarMdfeEncerrados: (idParticipante, dataInicio, dataFim) => {
    return httpCadastro.get(`${endpoint}/mdfe-encerrados`, {
      params: { idParticipante, dataInicio, dataFim }
    })
  },

  //
  // As chaves vao numa string separada por virgula, e nao como array: o
  // axios 0.26 serializa array como `chaves[]=a&chaves[]=b`, e o Spring
  // do outro lado espera `chaves=a&chaves=b`. Com o sufixo [] o parametro
  // nao casa e o filtro seria ignorado em silencio - a tela traria o
  // periodo inteiro achando que trouxe os MDF-e escolhidos. Virgula o
  // Spring converte sozinho em List<String>, e chave de acesso so tem
  // digito, entao nao ha o que escapar.
  //
  listar: (idParticipante, dataInicio, dataFim, chaves) => {
    const params = { idParticipante }
    if (chaves && chaves.length) {
      params.chaves = chaves.join(',')
    } else {
      params.dataInicio = dataInicio
      params.dataFim = dataFim
    }
    return httpCadastro.get(endpoint, { params })
  },

  //
  // Abre a rodada com os mesmos parametros da consulta: o que a rodada
  // congela e exatamente o que o operador viu.
  //
  // Se ja houver rodada aberta a API devolve aquela, com
  // reaproveitada=true, em vez de criar outra - dois cliques aqui
  // criariam duas rodadas com os mesmos milhares de CT-e.
  //
  // idUsuario vai so para auditoria; a autorizacao e por papel no token.
  //
  abrirRodada: (idParticipante, dataInicio, dataFim, chaves) => {
    return httpCadastro.post(`${endpoint}/lote`, {
      idParticipante,
      dataInicio: dataInicio || null,
      dataFim: dataFim || null,
      chaves: chaves && chaves.length ? chaves : [],
      idUsuario: Number(localStorage.getItem('id')) || null
    })
  },

  //
  // A rodada em andamento, ou 204 sem corpo quando nao ha nenhuma. O
  // axios entrega 204 como data vazia, e e isso que a tela checa.
  //
  rodadaAberta: (idParticipante) => {
    return httpCadastro.get(`${endpoint}/lote/aberto`, { params: { idParticipante } })
  },

  buscarRodada: (idLote, idParticipante) => {
    return httpCadastro.get(`${endpoint}/lote/${idLote}`, { params: { idParticipante } })
  },

  finalizarRodada: (idLote, idParticipante) => {
    return httpCadastro.post(`${endpoint}/lote/${idLote}/finalizar`, null,
      { params: { idParticipante } })
  },

  //
  // Onde estas chaves ja embarcaram. Mesma serializacao por virgula do
  // listar, pelo mesmo motivo: com sufixo [] o Spring ignoraria o
  // parametro e a resposta viria vazia em silencio.
  //
  embarcados: (idParticipante, chaves) => {
    return httpCadastro.get(`${endpoint}/embarcados`, {
      params: { idParticipante, chaves: (chaves || []).join(',') }
    })
  }
}
